import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoginState } from '@app/features/auth/model/login.interface';
import { Error } from '@app/shared/models/error.interface';
import { SessionState } from '@app/shared/models/session.interface';
import { Store } from '@app/shared/store/store';
import { DataTableState } from '@components/data/data-table-new/state/state.model';
import { MapState } from '@components/data/maps/state/state.model';

/**
 * The store state
 */
export interface AppState {
  loading?: boolean;
  error?: Error;
  session: SessionState;
  login?: LoginState;
  moduleState: { [key: string]: any };
  dataTableState: { [key: string]: DataTableState };
  mapState: { [key: string]: MapState };
}

/**
 * Create an initial state for the store.
 *
 * If the app requires additional states (e.g. order, customer, etc.),
 * each module must create a value in the modules entry.
 */
const initialState: AppState = {
  loading: false,
  session: {},
  moduleState: {}, //here will be inserted key/values entries representing the state of each module
  dataTableState: {},
  mapState: {}
};

@Injectable()
export class AppStore extends Store<AppState> {
  constructor(private router: Router) {
    super(initialState);
  }
}
